export const defaultFilter = {
  page: 1,
  limit: 25,
};
